import {ObjectDocumentAssocEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {ActionIcon, Box, Group, Modal, ModalProps, Stack, Table} from "@mantine/core";
import {IconDownload, IconTrash} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import { HasAccess } from "../../auth/HasAccess/HasAccess";
import { FormattedDateTime } from "../../date/FormattedDateTime/FormattedDateTime";
import { useObjectDocumentAssocMutation } from "../../../hooks/useObjectDocumentAssocMutation";

export type DocumentTableProps = {
  documents: ObjectDocumentAssocEntity[]
}

export const DocumentTable = (props: DocumentTableProps) => {
  const {documents} = props

  const {t} = useTranslation(["common"])

  const {
    deleteObjectDocumentAssoc
  } = useObjectDocumentAssocMutation()

  const onDeleteClick = useCallback((document: ObjectDocumentAssocEntity) => {
    deleteObjectDocumentAssoc(document.id, undefined)
  }, [deleteObjectDocumentAssoc])

  const tableRows = useMemo(() => {
    const rows = []

    for (const document of documents) {
      rows.push(
        <tr key={document.id}>
          <td>
            <Stack spacing="xs">
              {document.displayName}
              <FormattedDateTime date={document.createDttm} />
            </Stack>
          </td>
          <td>
            <Group>
              <ActionIcon component="a" href={document.url} target={"_blank"}>
                <IconDownload size={16}/>
              </ActionIcon>
              <HasAccess permissions={["edit"]}>
                <ActionIcon onClick={() => onDeleteClick(document)}>
                  <IconTrash color="red" size={16}/>
                </ActionIcon>
              </HasAccess>
            </Group>
          </td>
        </tr>
      )
    }

    return rows
  }, [documents, t])

  return (
    <Table>
      <tbody>
      {tableRows}
      </tbody>
    </Table>
  )
}

export type DocumentTableModalProps = Omit<ModalProps, "onSubmit"> & DocumentTableProps

export const DocumentTableModal = (props: DocumentTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.shared.file.plural", "Files"),
    documents,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <DocumentTable documents={documents}/>
      </Box>
    </Modal>
  );
};
